export const selectFilters = (state) => state.filters.name;
